import * as Sentry from '@sentry/react';

export const identifySentryUser = (userId) => {
  if (typeof userId !== 'string' && typeof userId !== 'number') return;
  const id = String(userId);
  if (!/^[a-zA-Z0-9_-]{1,128}$/.test(id)) return;

  try {
    Sentry.setUser({ id });
  } catch {
    // Error reporting must not interrupt authentication.
  }
};

export const clearSentryUser = () => {
  try {
    Sentry.setUser(null);
  } catch {
    // Error reporting must not interrupt sign-out.
  }
};
